module.exports = __webpack_public_path__ + "Lily Z. King-c770dc55.png";